<aside class="sidebar" [class.collapsed]="isCollapsed"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()">
    <ul class="nav flex-column mt-3">
        <li class="nav-item mb-3">
            <a class="nav-link px-3" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" routerLink="dashboard">
                <i class="fas fa-folder-open"></i>
                <span class="label" *ngIf="!isCollapsed">Expedientes <br> Activos</span>
            </a>
        </li>
        <li class="nav-item mb-3" *ngIf="isAdmin">
            <a class="nav-link px-3" routerLinkActive="active" routerLink="/app/dashboard/assign">
                <i class="fas fa-file-invoice"></i>
                <span class="label" *ngIf="!isCollapsed">Asignación de <br> Contratos</span>
            </a>
        </li>
    </ul>
</aside>